import React from 'react';
import { SolutionsList } from '../../../constants';
import LogoFooter from '../../../assets/imgs/logoFooter.svg';

import './index.scss';
import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="footer-wrap">
    <div className="container-layout foot">
      <div className="product-container">
        <div className="logo-info">
          <img alt="bme-logo" src={LogoFooter}/>
          <p className="footer-logo-txt">Create, manage and grow your iGaming business</p>
        </div>
        <p className="footer-year-txt"> (c) {new Date().getFullYear()} All rights reserved.</p>
        <div className="items">
          <p className="footer-items-title">Solutions</p>
          <ul>
            {
              SolutionsList.map(sl => {
                return (
                  <li key={sl.slug}>
                    <Link className="block-txt" to={`/${sl.path}`}>{sl.name}</Link>
                  </li>
                );
              })
            }
          </ul>
        </div>
        <div className="items">
          <p className="footer-items-title">Information</p>
          <ul>
            <li><a href="/knowledge-base">Knowledge Base</a></li>
            <li><a href="/services">Services</a></li>
            {/*<li><a href="/slot-builder">Slot Builder</a></li>*/}
            <li><a href="/products-blog">Products Blog</a></li>
            <li><a href="/about">About Us</a></li>
          </ul>
        </div>
        <div className="items">
          <p className="footer-items-title">Keep In Touch</p>
          <ul>
            <li><a href="/become-partner">Become a Partner</a></li>
            <li><a href="/request-demo">Request a Demo</a></li>
            <li><a href="/marketplace">Marketplace</a></li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
